export default "__VITE_ASSET__Dmgf$l6w__"